import { render, staticRenderFns } from "./ToggleSidebar.vue?vue&type=template&id=557154a8&scoped=true"
import script from "./ToggleSidebar.vue?vue&type=script&lang=js"
export * from "./ToggleSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToggleSidebar.vue?vue&type=style&index=0&id=557154a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557154a8",
  null
  
)

export default component.exports